import { useAtomValue } from "jotai";
import { hasZslAtom } from "@zapier/canvas-state";
import { EventAssetType } from "@zapier/observability";
import { Icon } from "@zapier/design-system";
import { Button } from "@zapier/design-system-beta";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

import styles from "./OpenAssetButton.module.css";

type Props = {
  href: string;
  assetNoun: string;
  eventAsset: EventAssetType;
};

export function OpenAssetButton({ href, assetNoun, eventAsset }: Props) {
  const hasZsl = useAtomValue(hasZslAtom);
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  if (hasZsl) {
    return null;
  }

  return (
    <div className={styles.buttonWrapper}>
      <Button
        size="compact"
        variant="tertiary"
        onPress={() => {
          emitEventOnAssetOpen({
            asset: eventAsset,
            location: "node",
          });

          window.open(href, "_blank");
        }}
      >
        <Icon name="miscWorld" size={30} />
        View published {assetNoun}
      </Button>
    </div>
  );
}
